export default {
  PRODUCT_ENABLED: {
    en: 'Enabled',
    fr: 'Actif'
  },
  PRODUCT_DISABLED: {
    en: 'Disabled',
    fr: 'Désactivé'
  },
  PRODUCT_MANUALLY_DISABLED: {
    en: 'Manually disabled',
    fr: 'Désactivé manuellement'
  },
  PRODUCT_DISABLED_FLUX: {
    en: 'Feed disabled',
    fr: 'Flux désactivé'
  },
  PAGE_ENABLED: {
    en: 'Enabled',
    fr: 'Active'
  },
  PAGE_DISABLED: {
    en: 'Disabled',
    fr: 'Désactivée'
  },
  FLUX_ENABLED: {
    en: 'Enabled',
    fr: 'Actif'
  },
  FLUX_DISABLED: {
    en: 'Disabled',
    fr: 'Désactivé'
  },
  FLUX_LENGOW_XML: {
    en: 'Lengow (XML)',
    fr: 'Lengow (XML)'
  },
  FLUX_GOOGLE_SHOPPING_FEED: {
    en: 'Google Shopping Feed',
    fr: 'Google Shopping Feed'
  },
  FLUX_AWIN_XML: {
    en: 'Awin (XML)',
    fr: 'Awin (XML)'
  },
  FLUX_TRADEDOUBLER_XML: {
    en: 'Tradedoubler (XML)',
    fr: 'Tradedoubler (XML)'
  },
  FLUX_CREATED: {
    en: 'Unprocessed',
    fr: 'Non traité'
  },
  FLUX_PENDING: {
    en: 'Pending',
    fr: 'En attente'
  },
  FLUX_PROCESSING: {
    en: 'Processing',
    fr: 'En traitement'
  },
  FLUX_ERROR: {
    en: 'Error',
    fr: 'Erreur'
  },
  FLUX_PROCESSED: {
    en: 'Processed',
    fr: 'Traité'
  },
  BRAND_HIDDEN: {
    en: 'Hidden',
    fr: 'Masqué'
  },
  BRAND_DISPLAYED: {
    en: 'Displayed',
    fr: 'Visible'
  },
  GENDER_MALE: {
    en: 'Male',
    fr: 'Homme'
  },
  GENDER_FEMALE: {
    en: 'Female',
    fr: 'Femme'
  },
  GENDER_NEUTRAL: {
    en: 'Neutral',
    fr: 'Neutre'
  }
}
